import React from 'react';
import MediaHero from '../components/MediaHero';
import MediaLogos from '../components/MediaLogos';

function MediaPage() {
  return (
    <div className="page">
      <MediaHero />
      <MediaLogos />
    </div>
  );
}

export default MediaPage;
